import React from 'react';
import { string, shape, bool } from 'prop-types';

import { modifiersMapper } from '~utils/product';

import styles from './styles.module.scss';

const UnavailableItem = ({ item, isModifier = false }) => {
  const modifiersFromProduct = !isModifier ? modifiersMapper(item.items, (modifier) => modifier.name) : [];
  return (
    <div className={`row m-bottom-2 ${styles.container}`}>
      {isModifier ? (
        <div className="column">
          <div className="row bold m-bottom-1">{item?.name}</div>
        </div>
      ) : (
        <>
          <div className={`column m-right-2 ${styles.badge}`}>{item.count}</div>
          <div className="column">
            <div className="row bold m-bottom-1">{item.product?.name}</div>
            {modifiersFromProduct.map((modifier) => (
              <div className="text-start" key={modifier}>
                {modifier}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default UnavailableItem;

UnavailableItem.propTypes = {
  isModifier: bool,
  item: shape({
    count: string,
    name: string
  })
};
